import {
    IGeoComplyResponse,
    IGeoLocationStrategy,
    IGeoLocationStrategyRunParams
} from "../geo-location.strategy.interface";
import {GeoComplyHtml5Client} from "./geo-comply-html5-client";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

export class GeoLocationHtml5Strategy implements IGeoLocationStrategy {

    constructor(services: IServiceFactoryExtended) {
        this._geoComplyClient = new GeoComplyHtml5Client(services);
    }

    private readonly  _geoComplyClient: GeoComplyHtml5Client;
    dispose(): void {
        this._geoComplyClient.dispose();
    }

    async runGeoLocation(params: IGeoLocationStrategyRunParams): Promise<IGeoComplyResponse> {
        return await this._geoComplyClient.runGeoLocation(params);
    }

}